import { ReactNode } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { cx } from '@emotion/css';

import { SignUpSlide } from './sign-up-slide';
import { useStyles } from './reg-guide-page.styles';
import { RegSteps } from './reg-steps';
import { Benefits } from './benefits';
import bannerReg from '../../../../assets/images/reg-guide/banner-reg.jpg';
import { adultSteps, childSteps } from './reg-guide-page.items';
import { Page } from '../page/page';

export const RegGuidePage = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const bannerAlt = 'Зарегистрируйтесь в приложении MyACUVUE®';

  return (
    <Page title={intl.formatMessage({ id: 'regGuide.title' })}>
      <SignUpSlide
        title="regGuide.ecp.banner.title"
        description="regGuide.banner.description"
      />
      <h2 className={classes.bannerReg} aria-label={bannerAlt} id="adult" tabIndex={-1}>
        <img width={375} height={231} src={bannerReg} alt="" />
      </h2>
      <div className={classes.root}>
        <p
          className={classes.paragraph}
          data-testid="happy-fitting"
        >
          <FormattedMessage id="regGuide.happyFitting" />
        </p>
        <p
          className={cx(classes.strong, classes.paragraph)}
          data-testid="save-fitting"
        >{intl.formatMessage(
          { id: 'regGuide.saveFitting' },
          { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
        )}</p>
        <p
          className={cx(classes.strong, classes.paragraph)}
          data-testid="bonus-notice"
        >{intl.formatMessage(
          { id: 'regGuide.bonusNotice' },
          { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
        )}</p>
        <RegSteps isEcp steps={adultSteps} />
      </div>
      <h2 className={classes.subtitle} id="child" tabIndex={-1}>
        {intl.formatMessage(
          { id: 'regGuide.ecp.subtitle' },
          {
            sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
            span: (chunks: ReactNode) => <span className={classes.block}>{chunks}</span>,
          },
        )}
      </h2>
      <p
        className={cx(classes.strong, classes.paragraph, classes.center)}
        data-testid="benefit"
      >{intl.formatMessage(
        { id: 'regGuide.ecp.subtitle.description' },
        { sup: (chunks: ReactNode) => <sup>{chunks}</sup>, nonBreakSpace: <>&nbsp;</> },
      )}</p>
      <RegSteps isEcp steps={childSteps} />
      <Benefits />
    </Page>
  );
};
